import axios from 'axios';
import { GET_BET_PL_API, GET_BET_RESULT_API, GET_MY_BET_API, POST_BET_API, SM_EventMARKET_API } from './url';
import { getAuthHeaders } from './authUtils';

class SMBetServiceClass {

    async getSMEventMarketService() {
        const headers = getAuthHeaders();
        return await axios.get(`${SM_EventMARKET_API}`, {
            headers: headers,
        });
    }

    async postBetAPIService(data) {
        const headers = getAuthHeaders();
        return await axios.post(`${POST_BET_API}`, data, {
            headers: headers,
        });
    }

    async getSMMyBetsService(mId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_MY_BET_API}?marketId=${mId}&uid=0`, {
            headers: headers,
        });
    }
    
    async getSMBetResultService(mId) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_BET_RESULT_API}`, {
            headers: headers,
        });
    }

    async getSMProfitAndLossService(data) {
        const headers = getAuthHeaders();
        return await axios.get(`${GET_BET_PL_API}?skipRec=${data?.skipRec}&psize=${data?.psize}&startDate=${data?.startDate}&endDate=${data?.endDate}&sportsId=${data?.sportsId}`, {
            headers: headers,
        });
    }

}

const SMBetService = new SMBetServiceClass();
export default SMBetService;
